<template>
  <div class="home">
    <div>
      <section>
        <div class="py-8 px-8">
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="col-12 col-lg-auto mb-4 mb-lg-0">
              <div class="d-flex align-items-center">
                <h4 class="mb-0 me-2">{{ $t('attendance_management') }}</h4>
              </div>
            </div>
            <div class="col-12 col-lg-auto d-flex align-items-center">
              <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="searchQuery" :placeholder="$t('search')">
                            </div>
            </div>
          </div>
        </div>
      </section>

      <section class="">
        <div class="px-8">
          <div class="row align-items-end g-2 mb-4">
            <div class="col-12 col-md-3 col-lg-2">
              <select v-model="status" class="form-select form-select-sm" name="Results" style="cursor:pointer">
                <option value="all">{{ $t('all') }}</option>
                <option value="not_checked_out">{{ $t('not_checked_out') }}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 col-lg-2">
              <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                <option value="">{{$t('filter_by_date')}}</option>
                <option value="today">{{$t('today')}}</option>
                <option value="yesterday">{{$t('yesterday')}}</option>
                <option value="this_week">{{$t('this_week')}}</option>
                <option value="last_week">{{$t('last_week')}}</option>
                <option value="this_month">{{$t('this_month')}}</option>
                <option value="custom">{{$t('custom_date')}}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
              <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
            </div>
            
            <!-- Spacer for desktop -->
            <div class="col d-none d-md-block"></div>
            
            <div class="col-md-2 d-none d-md-block">
              <button @click="createAttendanceState = true" class="btn btn-sm btn-success w-100">
                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                <span>{{ $t('check_in') }}</span>
              </button>
            </div>
          </div>

          <div class="page-table-container mb-6 bg-white rounded shadow">
            <div class="table-responsive">
              <table class="table mb-0 table-borderless table-striped small">
                <thead>
                  <tr class="text-secondary">
                    <th class="pt-4 pb-3 px-6">{{ $t('client') }}</th>
                    <sortable-table-header field="check_in" label="check_in" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, fetchAttendance)" />
                    <sortable-table-header field="check_out" label="check_out" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, fetchAttendance)" />
                    <th class="pt-4 pb-3 px-6">{{ $t('duration') }}</th>
                    <sortable-table-header field="notes" label="notes" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, fetchAttendance)" />
                    <th class="pt-4 pb-3 px-6">{{ $t('actions') }}</th>
                  </tr>
                </thead>
                <tbody> 
                  <tr v-for="record in filteredAttendance" :key="record.id">
                    <td class="py-5 px-6">{{ record?.client?.name }}</td>
                    <td class="py-5 px-6">{{ formatDateTimeForInput(record.check_in) }}</td>
                    <td class="py-5 px-6">{{ record.check_out ? formatDateTimeForInput(record.check_out) : '-' }}</td>
                    <td class="py-5 px-6">{{ calculateDuration(record) }}</td>
                    <td class="py-5 px-6">{{ record.notes || '-' }}</td>
                    <td class="py-5 px-6">
                      <button v-if="!record.check_out" @click="checkOut(record.id)" :disabled="loading" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-success btn-xs">
                        {{ $t('check_out') }}
                      </button>
                      <button @click="editRecord(record)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                        {{ $t('edit') }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="count > attendance.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
              <compact-pagination :pages="pagination" :current-page="page" @change="fetchAttendance" />
            </div>
                                <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !attendance.length" class="page-table-state text-center" style="padding:1rem">{{$t('no_attendance_found')}}.</div>
          </div>
          <div class="col-sm-7">
            {{$t('show')}}
            <select v-model="per_page" class="form-select form-select-sm d-inline-block w-auto mx-2" name="Results" style="cursor:pointer">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            {{$t('entities')}}
          </div>
        </div>


      </section>

    </div>

    <!-- Check-in Modal -->
    <add-attendance 
      v-if="createAttendanceState"  
      :state="createAttendanceState"
      @createAttendance="createAttendance"/>
    <!-- Check-in Modal -->

    <!-- Edit Modal -->
    <div class="modal fade" :class="{ show: showEditModal }" tabindex="-1" role="dialog" :style="{ display: showEditModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('edit_attendance_record') }}</h5>
            <button type="button" class="btn-close" @click="showEditModal = false"></button>
          </div>
          <div class="modal-body" style="text-align:left">
            <form @submit.prevent="updateRecord" class="edit-form">
              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('check_in_time') }}</label>
                  <input type="datetime-local" v-model="editForm.checkIn" class="form-control" required>
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('check_out_time') }}</label>
                  <input type="datetime-local" v-model="editForm.checkOut" class="form-control">
                </div>
                <div class="col-sm-12 mb-3">
                  <collapsible-notes-field v-model="editForm.notes" id="attendance-edit-notes" rows="1" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showEditModal = false">{{ $t('close') }}</button>
            <button type="button" class="btn btn-primary" @click="updateRecord">{{ $t('save_changes') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showCheckInModal || showEditModal" class="modal-backdrop fade show"></div>

    <!-- Add Subscription Overview Component -->
    <SubscriptionOverview v-if="false" />
  </div>
</template>

<script>
import helper from '../helper';
import SubscriptionOverview from '../components/SubscriptionOverview.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import AddAttendance from '../components/AddAttendance.vue';
import sortableList from '../mixins/sortableList'

export default {
  name: 'Attendance',
  persistedFilterState: {
    key: 'attendance',
    fields: ['searchQuery', 'status', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components: {
    SubscriptionOverview,
    DatePicker,
    AddAttendance
  },
  data() {
    return {
      attendance: [],
      activeClients: [],
      showCheckInModal: false,
      showEditModal: false,
      searchQuery: '',
      status: 'all',
      range: [],
      start: null,
      end: null,
      page: 1,
      count: 0,
      pagination: [],
      per_page: 25,
      dateRangeOption: '',
      checkInForm: {
        clientId: '',
        client: null,
        notes: ''
      },
      editForm: {
        id: null,
        checkIn: '',
        checkOut: '',
        notes: ''
      },
      createAttendanceState: false
    };
  },
  computed: {
    filteredAttendance() {
      if (!this.searchQuery) {
        return this.attendance;
      }
      
      const searchTerm = this.searchQuery.toLowerCase();
      return this.attendance.filter(record => {
        const clientName = record?.client?.name?.toLowerCase() || '';
        return clientName.includes(searchTerm);
      });
    }
  },
  watch: {
    status() {
      this.fetchAttendance();
    },
    async searchQuery() {
      if(this.searchQuery.length > 2) {
        this.fetchAttendance();
      }
      if(this.searchQuery == '') {
        this.fetchAttendance();
      }
    },
    range() {
      if (this.range[0] == null) {
        this.start = null;
        this.end = null;
        this.fetchAttendance();
      }

      if (this.range.length && this.range[0] && this.range[1]) {
        this.start = moment(this.range[0]).format('YYYY-MM-DD');
        this.end = moment(this.range[1]).format('YYYY-MM-DD');
        this.fetchAttendance();
      } else {
        this.attendance = [];
      }
    },
    per_page() {
      this.fetchAttendance(this.page);
    }
  },
  methods: {
    async fetchActiveClients() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/clients`);
        this.activeClients = response.data.data;
      } catch (error) {
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_active_clients'),
          type: 'error',
          position: 'bottom'
        });
      }
    },

    async saveCheckIn() {
      try {
        this.loading = true;
        await helper.customPost(`${process.env.VUE_APP_API}/attendance`, {
          clientId: this.checkInForm.clientId,
          checkIn: new Date().toISOString(),
          notes: this.checkInForm.notes
        }, { showToast: true });
        await this.fetchAttendance();
        this.showCheckInModal = false;
        this.resetCheckInForm();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_save_check_in'),
          type: 'error',
          position: 'bottom'
        });
      }
    },

    async checkOut(id) {
      try {
        this.loading = true;
        await helper.customPatch(`${process.env.VUE_APP_API}/attendance/${id}`, {
          checkOut: new Date().toISOString()
        }, { showToast: true });
        await this.fetchAttendance();
        this.loading = false;

      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_check_out'),
          type: 'error',
          position: 'bottom'
        });
      }
    },

    editRecord(record) {
      this.editForm = {
        id: record.id,
        checkIn: this.formatDateTimeForInput(record.check_in),
        checkOut: record.check_out ? this.formatDateTimeForInput(record.check_out) : '',
        notes: record.notes || ''
      };
      this.showEditModal = true;
    },

    async updateRecord() {
      try {
        await helper.customPatch(`${process.env.VUE_APP_API}/attendance/${this.editForm.id}`, {
          checkIn: this.editForm.checkIn,
          checkOut: this.editForm.checkOut,
          notes: this.editForm.notes
        }, { showToast: true });
        await this.fetchAttendance();
        this.showEditModal = false;
      } catch (error) {
        window.vueOpener.open({
          message: this.$t('failed_to_update_record'),
          type: 'error',
          position: 'bottom'
        });
      }
    },

    formatDateTime(date) {
      return helper.formatDate(date);
    },

    formatDateTimeForInput(date) {
      if (!date) return '';
      const d = new Date(date);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
    },

    calculateDuration(record) {
      if (!record.check_out) return '-';
      const checkIn = new Date(record.check_in);
      const checkOut = new Date(record.check_out);
      const duration = checkOut - checkIn;
      const hours = Math.floor(duration / (1000 * 60 * 60));
      const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
      return `${hours}h ${minutes}m`;
    },

    resetCheckInForm() {
      this.checkInForm = {
        clientId: '',
        client: null,
        notes: ''
      };
    },

    filterAttendance() {
      // The filtering is handled by the computed property
    },

    // Fetch all attendance records (generic)
    async fetchAttendance(page) {
      try {
        this.loading = true;
        this.page = page ? page : 1;
        this.attendance = this.page == 1 ? [] : this.attendance;
        
        const params = new URLSearchParams({ page: this.page, per_page: this.per_page });
        this.appendSortParams(params);
        
        if (this.status !== 'all') {
          params.append('status', this.status);
        }
        
        if(this.searchQuery != "") {
          params.append('keyword', this.searchQuery);
        }

        if (this.start && this.end) {
          params.append('start', this.start);
          params.append('end', this.end);
        }
        const url = `${process.env.VUE_APP_API}/attendance?${params.toString()}`;
        
        const response = await helper.customGet(url);
        this.attendance = response.data.data;
        
        if(this.per_page != response.data.per_page) {
          this.per_page = response.data.per_page;
        }

        this.page = response.data.current_page;
        this.count = response.data.count;
        this.loading = false;

        //pagination
        this.pagination = [];
        let MaxPagination = Math.ceil(this.count / this.per_page);
        for(let i = 1; i <= MaxPagination; i++) {
          this.pagination.push(i);
        }
      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_attendance'),
          type: 'error',
          position: 'bottom'
        });
      }
    },

    createAttendance(data) {
      if (data.attendance) {
        this.attendance.push(data.attendance);
      }
      this.fetchAttendance()
      if (data && data.state != undefined) {
        this.createAttendanceState = data.state;
      }
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.fetchAttendance()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    }
  },
  mounted() {
    window.mixpanel.track("attendance");

    
    //check permissions
    if(helper.checkAccess('view_attendance') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_attendance') == -2) return this.$router.push({path : '/subscribe'})

    // Initialize this_month date range
    // this.handleDateRangeChange();

    this.fetchAttendance();
    this.fetchActiveClients();
  }
};
</script>

<style scoped>
.table-borderless>:not(caption)>*>* {
  padding: 5px !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.modal {
  z-index: 1050;
}
</style>
